export default __webpack_public_path__ + "src/static/img/png/woman-get-phone-and-put-details-delivery.png";